import { getPathFromPageId } from '~/shared/helpers/getPathFromPageId'
import { IStep } from '~/shared/types/variantTypes'

interface IParams {
  pages: IStep[]
  currentPageIndex: number
  cohort: string
  availableRoute: string
  uuid: string
  search: string
}

export const prepareNavigationProps = ({
  pages,
  cohort,
  currentPageIndex,
  uuid,
  availableRoute,
  search,
}: IParams) => {
  const prevPage = pages[currentPageIndex - 1]
  const nextPage = pages[currentPageIndex + 1]

  const nextPagePath = nextPage
    ? getPathFromPageId({
        pageId: nextPage.id,
        cohort,
        uuid,
        currentSearch: search,
      })
    : ''
  const prevPagePath = prevPage
    ? getPathFromPageId({
        pageId: prevPage.id,
        cohort,
        uuid,
        currentSearch: search,
      })
    : ''

  const alternativePageId = pages.find(
    (dynamicPage, dynamicPageIndex) =>
      !dynamicPage.isSkippable && dynamicPageIndex > currentPageIndex,
  )?.id

  const alternativePagePath = getPathFromPageId({
    pageId: alternativePageId || nextPage?.id,
    cohort,
    uuid,
    currentSearch: search,
  })

  return {
    nextPagePath,
    prevPagePath: availableRoute || prevPagePath || '',
    alternativePagePath,
  }
}
